// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonRefresh_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 15C10.3787 15 12.4804 13.8135 13.7453 12H11.0005C10.1647 12.6279 9.12582 13 8 13 5.23858 13 3 10.7614 3 8H4L2 5 0 8H1C1 11.866 4.13401 15 8 15ZM2.25469 4C3.51964 2.18652 5.62125 1 8 1 11.866 1 15 4.13401 15 8H16L14 11 12 8 13 8C13 5.23858 10.7614 3 8 3 6.87418 3 5.83526 3.37209 4.99951 4H2.25469Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 4C9.97111 4 8.11862 4.75527 6.70835 6H3.99927C5.82368 3.57111 8.72836 2 12 2 17.5228 2 22 6.47715 22 12H24L21 16 18 12H20C20 7.58172 16.4183 4 12 4ZM12 20C14.0289 20 15.8814 19.2447 17.2916 18H20.0007C18.1763 20.4289 15.2716 22 12 22 6.47715 22 2 17.5228 2 12L0 12 3 8 6 12H4C4 16.4183 7.58172 20 12 20Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M27 16C27 15.9999 27 16.0001 27 16H29C29 15.9999 29 16.0001 29 16H27ZM26.8186 14H28.8471C27.8851 7.76982 22.4996 3 16 3 11.3732 3 7.31092 5.41711 5.00704 9.05749L6.34337 10.7279C8.21077 7.31472 11.8351 5 16 5 21.3921 5 25.8781 8.87976 26.8186 14ZM26.9928 22.9427 25.6565 21.2723C23.7891 24.6854 20.1648 27 16 27 10.608 27 6.12212 23.1204 5.18145 18.0004H3.15296C4.11513 24.2304 9.50056 29 16 29 20.6267 29 24.6889 26.583 26.9928 22.9427Z" class="svg-bg"/>
  <path d="M32 16H29C29 8.8203 23.1797 3 16 3 11.3976 3 7.35377 5.39169 5.04364 9H7.51432C9.53191 6.55699 12.5841 5 16 5 22.0751 5 27 9.92487 27 16L24 16 28 21 32 16ZM21 25.8006C19.4999 26.5674 17.8004 27 16 27 9.92487 27 5 22.0751 5 16H8L4 11 0 16H3C3 23.1797 8.8203 29 16 29 19.1588 29 22.0545 27.8734 24.3071 26H21V25.8006Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonRefresh is a generated icon component.
 */
let IconCommonRefresh = IconCommonRefresh_1 = class IconCommonRefresh extends IconBaseElement {
    render() {
        return html `${IconCommonRefresh_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonRefresh.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconCommonRefresh = IconCommonRefresh_1 = __decorate([
    customElement('zui-icon-common-refresh')
], IconCommonRefresh);
export { IconCommonRefresh };
